<template>
  <div class="container" style="padding-top: 90px; padding-bottom: 30px;">
    <LifeHeader :header="mySchool.header"></LifeHeader>
    <div class="content">
      <SubHeader :backgroundUrl="mySchool.headerUrl"></SubHeader>
      <div class="detail">
        <div class="item">
          <div class="row">
            <div class="col-3">
              <p class="head">{{mySchool.type.key}}<span>:</span></p>
            </div>
            <div class="col-9">
              <p>{{mySchool.type.value}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3 item-img" v-for="(image, index) in mySchool.typeImages" :key="index">
              <img :src="`/${$staticPath}/${image}`">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="row">
            <div class="col-3">
              <p class="head">{{mySchool.color.key}}<span>:</span></p>
            </div>
            <div class="col-9">
              <p><span class="orange">{{mySchool.color.value[0]}}</span> {{mySchool.color.value[1]}} <span class="grey">{{mySchool.color.value[2]}}</span></p>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <p class="head">{{mySchool.location.key}}<span>:</span></p>
            </div>
            <div class="col-9">
              <p>{{mySchool.location.value}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3 item-img" v-for="(image, index) in mySchool.locationImages" :key="index">
              <img :src="`/${$staticPath}/${image}`">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item-bg" :style="{ backgroundImage: `url('/${$staticPath}/${mySchool.uniform.backgroundUrl}')` }"></div>
          <div class="row">
            <div class="col-3">
              <p class="head">{{mySchool.uniform.key}} <span>:</span></p>
            </div>
            <div class="col-9">
              <p v-for="(item, index) in mySchool.uniform.value" :key="index"><b v-html="item.main"></b> - <span v-html="item.detail"></span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LifeHeader from './Life_Header.vue'
import SubHeader from './Life_SubHeader.vue'

export default {
  components: {
    LifeHeader,
    SubHeader
  },
  props: ['mySchool'],
  data () {
    return {
      width: window.innerWidth
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.resizeMobile(), true)
    })
  },
  methods: {
    resizeMobile: function () {
      this.width = window.innerWidth
    }
  },
  computed: {
    isMobile: function () {
      return (this.width > 768)
    }
  }
}
</script>

<style scoped>
  .head {
    color: #FFA500;
    font-weight: 500;
    position: relative;
  }

  .head span {
    color: #353535;
    position: absolute;
    right: 0;
    top: 0;
  }

  .orange {
    color: #FFA500;
  }

  .grey {
    color: #909090;
  }

  .item {
    padding: 15px 0;
    position: relative;
  }

  .item .item-bg {
    position: absolute;
    top: 40px;
    left: 0px;
    opacity: 0.35;
    width: 60%;
    height: 90%;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .item .item-img {
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: center;
  }

  .item img {
    width: 80%;
    background-color: rgba(180, 180, 180, 0.2);
    border: 0.5px solid rgba(180, 180, 180, 0.1);
    border-radius: 3px;
    padding: 3px;
    transition: 0.35s;
  }

  .item .item-img img:hover {
    background-color: #FFA500;
  }
</style>



// WEBPACK FOOTER //
// src/components/STUDENTS/Life_Myschool.vue